import { render } from "./wren-profile.vue?vue&type=template&id=777785cc&scoped=true"
import script from "./wren-profile.vue?vue&type=script&lang=js"
export * from "./wren-profile.vue?vue&type=script&lang=js"

import "./wren-profile.vue?vue&type=style&index=0&id=777785cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-777785cc"

export default script